import { Product, VariantInfo } from '@model/product';

export const hasMoreThanOneVariant = (variantInfo?: VariantInfo) =>
  Boolean(variantInfo && Object.keys(variantInfo).length > 0 && (variantInfo.variants?.length ?? 0) > 1)
